export const environment = {
  env: 'PROD',
  production: true,
  serverBaseUrl: 'https://bkpaperlife.vaixscontrol.com/public/api',
  serverUrl: 'https://bkpaperlife.vaixscontrol.com/public/api',
  imgUrl: 'https://bkpaperlife.vaixscontrol.com/public/images/'
  // serverBaseUrl: 'http://bkprueba.paperlife.website/public/api',
  // serverUrl: 'http://bkprueba.paperlife.website/public/api',
  // imgUrl: 'http://bkprueba.paperlife.website/public/images/'
};
